import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2, Crown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { fetchPaymentStatus, usePremium } from "@/context/PremiumContext";

export default function PaymentSuccess() {
  const premium = usePremium();
  const [state, setState] = useState("checking"); // checking | paid | timeout

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setState("timeout");
      return;
    }
    let tries = 0;
    let active = true;
    const poll = async () => {
      if (!active) return;
      tries += 1;
      try {
        const s = await fetchPaymentStatus(sessionId);
        if (s.payment_status === "paid") {
          setState("paid");
          premium && premium.refresh && premium.refresh();
          return;
        }
      } catch (e) {
        console.debug("Paiement en attente, nouvelle tentative…", e);
      }
      if (tries >= 8) {
        setState("timeout");
        return;
      }
      setTimeout(poll, 2000);
    };
    poll();
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-5 py-16 text-center" data-testid="payment-success-page">
      {state === "checking" && (
        <>
          <Loader2 className="mb-4 h-10 w-10 animate-spin text-amber-500" />
          <h1 className="text-xl font-bold">Confirmation du paiement…</h1>
          <p className="mt-2 text-sm text-muted-foreground">Un instant, nous activons votre abonnement.</p>
        </>
      )}
      {state === "paid" && (
        <Card className="w-full border-amber-500/40 p-6" data-testid="payment-confirmed">
          <CheckCircle2 className="mx-auto mb-3 h-12 w-12 text-emerald-500" />
          <h1 className="text-xl font-bold">Bienvenue dans vspo Premium <Crown className="inline h-5 w-5 text-amber-500" /></h1>
          <p className="mt-2 text-sm text-muted-foreground">Votre abonnement est actif. La publicité a été retirée et toutes les fonctions premium sont débloquées.</p>
          <div className="mt-5 flex justify-center gap-3">
            <Button asChild><Link to="/">Ouvrir le GPS</Link></Button>
            <Button variant="outline" asChild><Link to="/compte">Mon compte</Link></Button>
          </div>
        </Card>
      )}
      {state === "timeout" && (
        <Card className="w-full p-6" data-testid="payment-pending">
          <h1 className="text-xl font-bold">Paiement en cours de traitement</h1>
          <p className="mt-2 text-sm text-muted-foreground">Votre paiement est pris en compte. Le statut Premium peut prendre quelques instants à apparaître.</p>
          <div className="mt-5 flex justify-center gap-3">
            <Button asChild><Link to="/compte">Vérifier mon compte</Link></Button>
          </div>
        </Card>
      )}
    </div>
  );
}
